// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */

/* eslint-disable no-restricted-syntax */
import type { PageSegmentLoadPerformanceEventFactoryConfig } from '@atlassian/browser-metrics/factory/types';
import { metrics } from '@atlassian/browser-metrics/factory';
import type { PageSegmentLoadMetric } from '@atlassian/browser-metrics/page-segment-load';

const pageSegmentLoad: (
	config: PageSegmentLoadPerformanceEventFactoryConfig,
) => PageSegmentLoadMetric = metrics.pageSegmentLoad;

/**
 * Raw, ungated BM3 page-segment-load factory.
 *
 * **Do NOT import this directly from product code.** The public, gated API is
 * `createPageSegmentLoadMetric` from
 * `@confluence/browser-metrics/entry-points/metricConfigs.ts` — that one selects a path
 * for each run using the static experience list and `cc_bm3_deprecation_phase_2` guard.
 *
 * This raw export exists in its own module purely so the gated wrapper
 * (`./createGatedPageSegmentLoadMetric.ts`) can consume it without creating a circular
 * dependency through `./metricConfigs.ts`. It is also re-exported from the dedicated
 * `entry-points/createBM3PageSegmentLoadMetricRaw.ts` entry point for the rare cases where
 * an explicit raw BM3 reference is required (e.g. parity tests during the gate ramp).
 *
 * See `next/packages/browser-metrics/AGENTS.md` → Phase 3 for context.
 */
export { pageSegmentLoad as createBM3PageSegmentLoadMetricRaw };
